import { KlaviyoIcon } from '@mm/icons';
import { useSignalConfigurationCRUDActions } from '@mm/state/actions/SignalConfigurationCRUDActions';
import { Configuration } from '@mm/state/model/SignalModel';
import { selectSignalEvents } from '@mm/state/selectors/signalSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { Switch } from 'antd';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styles from './KlaviyoSendingSwitch.module.css';

export const KlaviyoSendingSwitch = () => {
  const configuration = useSelector(
    (state: StoreState) => state.signalConfiguration.configuration,
  );

  const configurationId = (configuration as Configuration)?.id;

  const isSignalOn = configuration?.integrations.includes('klaviyo');

  const { update: updateConfiguration } = useSignalConfigurationCRUDActions();

  const events = useSelector(selectSignalEvents);

  const eventsSent = useMemo(() => {
    if (!events) return '0';

    const klaviyoEvents = Object.keys(events)
      .filter(key => key.startsWith('klaviyo'))
      .reduce((sum, key) => {
        const eventValues = Object.values(events[key]);
        return sum + eventValues.reduce((acc, value) => acc + value, 0);
      }, 0);

    return new Intl.NumberFormat().format(klaviyoEvents);
  }, [events]);

  return (
    <div className={styles.container}>
      <div>
        <Switch
          checked={isSignalOn}
          onChange={ok => {
            if (configurationId) {
              const existingIntegrationsWithoutKlaviyo =
                configuration?.integrations.filter(
                  integration => integration !== 'klaviyo',
                ) || [];
              const updatedIntegrations = ok
                ? [...existingIntegrationsWithoutKlaviyo, 'klaviyo']
                : existingIntegrationsWithoutKlaviyo;
              updateConfiguration({
                id: configurationId,
                integrations: updatedIntegrations,
              });
            }
          }}
        />
      </div>
      <KlaviyoIcon
        color="black"
        style={{
          width: '32px',
          height: '24px',
          marginLeft: '20px',
        }}
      />
      <div className={styles.title}>Klaviyo</div>
      <div>{eventsSent} events sent</div>
    </div>
  );
};
